import {REPORT_PROJECTED_PREMIER_VOLUME} from '/enum/records.enum';

export default {
  reportName: REPORT_PROJECTED_PREMIER_VOLUME,
};
